import { render, staticRenderFns } from "./PublicTabs.vue?vue&type=template&id=116f3cf8&scoped=true&"
import script from "./PublicTabs.vue?vue&type=script&lang=js&"
export * from "./PublicTabs.vue?vue&type=script&lang=js&"
import style0 from "./PublicTabs.vue?vue&type=style&index=0&id=116f3cf8&prod&lang=scss&scoped=true&"
import style1 from "./PublicTabs.vue?vue&type=style&index=1&id=116f3cf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f3cf8",
  null
  
)

export default component.exports